// Import the functions you need from the SDKs you need

import { getApp, getApps, initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// import { getMessaging, getToken } from 'firebase/messaging';
import {
  initializeAuth,
  // getReactNativePersistence
} from "firebase/auth";
// import ReactNativeAsyncStorage from '@react-native-async-storage/async-storage';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
const {
  REACT_APP_API_KEY,
  REACT_APP_AUTH_DOMAIN,
  REACT_APP_PROJECT_ID,
  REACT_APP_STORAGE_BUCKET,
  REACT_APP_MESSAGING_SENDER_ID,
  REACT_APP_APP_ID,
  REACT_APP_MEASUREMENT_ID,
  // eslint-disable-next-line no-undef
} = process.env || {};
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: REACT_APP_API_KEY,
  authDomain: REACT_APP_AUTH_DOMAIN,
  projectId: REACT_APP_PROJECT_ID,
  storageBucket: REACT_APP_STORAGE_BUCKET,
  messagingSenderId: REACT_APP_MESSAGING_SENDER_ID,
  appId: REACT_APP_APP_ID,
  measurementId: REACT_APP_MEASUREMENT_ID,
};

// Initialize Firebase
console.log("object firebaseConfig", firebaseConfig);
let app, auth, db, storage, messaging;
try {
  if (!getApps().length) {
    app = initializeApp(firebaseConfig);
    db = getFirestore(app);
    auth = initializeAuth(app, {
      // persistence: getReactNativePersistence(ReactNativeAsyncStorage)
    });
    // messaging = getMessaging(app)
    // getToken(messaging, { vapidKey: "BEmVPLtvCGBiv3ijb15gd7utzrf2Xa-13AF6n01i52ZY_63gmvWb3_a0dMkeAudLSuY9tB2yR01nB-mkvcu1XOg" });
    storage = getStorage(app);
  } else app = getApp();
  console.log("Successful conn");
} catch (err) {
  // just for testing mode removing in prod
  console.log("error initializing", err, process.env);
}

export { app, db, auth, storage, messaging };
